'use client';

import Link from '@next-app/components/elements/Link/Link';
import classes from './lakeshore-icon.module.scss';
import { selectIsGSAUser } from '@next-app/lib/features/InitSelectors';
import { useSelector } from 'react-redux';
import { getIsFurnitureTab } from '@next-app/utils/common-utils';

export default function LakeshoreIcon({
  customClass,
}: {
  customClass?: string;
}) {
  const isFurniture = getIsFurnitureTab();
  const isGSAUser = useSelector(selectIsGSAUser);

  return (
    <Link
      className={`header-link ${classes['ll-logo']} ${customClass ? classes[customClass] : ''}`}
      href={isFurniture ? '/furniture/' : '/'}
      data-updated="false"
      data-testid="lakeshore-icon"
      aria-label={`Go to ${isFurniture ? 'Furniture' : 'Lakeshore'} Homepage`}
    >
      <span
        automation-id="lakeshore_logo"
        className={`${classes['logos-sprites']} ${classes[isFurniture && !isGSAUser ? 'lf-logo-black' : 'll-logo-red']}`}
        title="Lakeshore® Learning Materials. Teacher supply store offering educational products, classroom furniture, decor and so much more."
      ></span>
      <span style={{ display: 'none' }} className="ae-compliance-indent">
        {`Lakeshore ${isFurniture ? 'Furniture ' : ''}Logo`}
      </span>
    </Link>
  );
}
